import * as disputes from './list'

import { Dispute } from '@/types/transactions/dispute'

export const allDisputes: Dispute[] = Object.values(disputes).sort(
    (previous, current) => current.date_time.localeCompare(previous.date_time),
)
